export default <T>(val: T | T[] | undefined): T[] => {
  if (typeof val === 'undefined') {
    return [];
  }
  return Array.isArray(val) ? [...val] : [val];
};
